export default __webpack_public_path__ + "static/media/pak4.20728bac.jpg";